(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function formatMoney(amount, format) {
      if (amount == null) return '';
      var value = parseFloat(amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      if (format) {
        return format
          .replace('{{amount}}', value)
          .replace('{{amount_no_decimals}}', Math.floor(amount))
          .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
          .replace('{{amount_no_decimals_with_comma_separator}}', Math.floor(amount));
      }
      var currency = (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : '';
      return currency + ' ' + value;
    }

    function getMoneyFormat() {
      return (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : null;
    }

    function buildResultsHTML(products) {
      if (!products || products.length === 0) {
        return '<div class="predictive-no-results">No results found</div>';
      }
      var moneyFormat = getMoneyFormat();
      return products.map(function(p) {
        var price = (p.price != null) ? formatMoney(p.price, moneyFormat) : '';
        var compareHTML = '';
        if (p.compare_at_price_max && p.compare_at_price_max > p.price) {
          compareHTML = '<span class="predictive-item-compare">' + formatMoney(p.compare_at_price_max, moneyFormat) + '</span>';
        }
        var img = (p.featured_image && p.featured_image.url)
          ? '<img src="' + p.featured_image.url + '" alt="' + p.title + '" onerror="this.style.display=\'none\'">'
          : '<div style="width:48px;height:48px;background:#f0f0f0;border-radius:4px;flex-shrink:0;"></div>';
        return '<a href="' + p.url + '" class="predictive-item">'
          + img
          + '<div class="predictive-item-info">'
          + '<div class="predictive-item-title">' + p.title + '</div>'
          + '<div class="predictive-item-prices">'
          + '<span class="predictive-item-price">' + price + '</span>'
          + compareHTML
          + '</div></div></a>';
      }).join('');
    }

    function attachSearch(inputId, resultsId) {
      var input = document.getElementById(inputId);
      var results = document.getElementById(resultsId);
      if (!input || !results) return;
      var debounceTimer;
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var query = this.value.trim();
        if (query.length < 2) {
          results.innerHTML = '';
          results.classList.remove('active');
          return;
        }
        debounceTimer = setTimeout(function() {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              results.innerHTML = buildResultsHTML(data.resources.results.products);
              results.classList.add('active');
            })
            .catch(function() { results.classList.remove('active'); });
        }, 300);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var q = input.value.trim();
          if (q.length > 0) window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      });
      if (inputId === 'InlineSearchDesktop') {
        var btn = document.getElementById('InlineSearchBtn');
        if (btn) {
          btn.addEventListener('click', function () {
            var q = input.value.trim();
            if (q.length > 0) window.location.href = '/search?q=' + encodeURIComponent(q);
          });
        }
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.inline-search-desktop') && !e.target.closest('.mobile-search-bar')) {
        document.querySelectorAll('.predictive-results').forEach(function(r) { r.classList.remove('active'); });
      }
    });

    attachSearch('InlineSearchDesktop', 'InlinePredictiveResults');
    attachSearch('MobileSearchInput', 'MobilePredictiveResults');
  })();

  } catch(e) { console.error(e); }
})();
})();
